<div class="top-header">
  <!-- (click)="leftMenuSlide()" -->

  <!-- *ngIf="!isHorizontalLayout" -->
  <!-- <div class="menu-bar-btn" (click)="leftMenuSlide()">
    <i class="e-line-normal e-icons"></i>
  </div> -->

  <!-- left side -->
  <!-- App switcher -->
  <div class="col-2 d-flex p-0">
    <app-switcher [isAdminRoute]="isAdminRoute"></app-switcher>
    <div class="horizontallogo ms-3"> 
      <!-- Dynamic logo bind -->
      <img *ngIf="orgLogo" [src]="orgLogo" class="logo">
      <!-- Static Logo bind -->
      <!-- <img src="../../assets/images/app/pms-logo.png" style="max-width: 30px;margin-left: 1.2rem;top: 2px;position: relative;"> -->
        <!-- <img width="100%" height="35"
          [src]="orgInfo?.Org_Menu_Logo ? orgInfo?.Org_Menu_Logo : '../../assets/images/app/techapp_force.svg'"
        /> -->
    </div>
  </div>

  <!--horizontal menu -->
  <div class="menu-control horizontal-menu col-7 p-0" *ngIf="isHorizontalLayout">
    <ejs-menu
      #menuObj
      class="ejsMenu"
      [items]="menuItems"
      [enableScrolling]="true"
      cssClass="e-custom-scroll"
      (select)="onMenuItemClicked($event)"
      (beforeOpen)="onMenuItemBeforeOpen($event)"
    ></ejs-menu>
    <!-- [enableScrolling]="enablescroll"
      [cssClass]="menuCssClass" -->
  </div>

  <!-- right side -->
  <div *ngIf="!isAdminRoute" class="top-header-right">
    <div>
      <select (change)="onChangeLanguage($event)" class="form-control">
        @for(language of languageList; track language?.SystemValue) {
          <option [value]="language.SystemValue" [selected]="language.SystemValue === selectedLanguage">{{ language.DisplayValue }}</option>
        }
      </select>
    </div>

    <div>
      <select 
      class="form-control" 
      (change)="onChangeEnvironment($event)" 
      *ngIf="isShowUserEnvironment && environmentList.length > 1">
      <option 
        *ngFor="let env of environmentList" 
        [value]="env.AppEnvironmentId"
        [selected]="environment === env.AppEnvironmentId"
      >
        {{ env.EnvironmentName }}
      </option>
    </select>
    </div>
    <div class="document-btn" (click)="goToDocuments()">
        <span class="e-icons e-file-document"></span>
    </div>
    <div class="top-header-icon" (click)="rebuildApp()" *ngIf="isBuildAndDevelopeModeUsercanAccess">
      <i [ngClass]="showLoader ? 'loader-build' : ''" class="refresh-icon"></i>
    </div>
    <div class="top-header-icon" (click)="onFullScreenClick()">
      <i
        [ngClass]="{
          'expand-icon': !fullScreen,
          'collapse-icon': fullScreen
        }"
      >
      </i>
    </div>
    @if (environmentName === 'Development') {
      <div class="top-header-icon" (click)="toggleDebugTools()" title="Debug">
        <i class="fa fa-bug" style="font-size: 16px"></i>
      </div>
    }
    <div class="top-header-icon" (click)="showSearch()">
      <i style="font-size: 17px" class="e-search e-icons"></i>
    </div>
    <!-- (click)="showNotification()" -->
    <div class="top-header-icon" (click)="showNotification()">
      <i style="font-size: 24px" class="notification-bell"></i>
      <!-- Badge for notification count -->
      <span class="badge-container">
        <span class="badge">{{ notificationCount }}</span>
        <!-- <span class="badge">12</span> -->
      </span>
    </div>
    <!-- (click)="userDropDown()" -->
    <div class="top-header-icon user-dd-menu" (click)="userDropDown()">
      <i style="font-size: 24px" class="user-icon"></i>
    </div>
  </div>

  <div *ngIf="isAdminRoute && appNavigation" class="return-app-link" (click)="navigateToApp()">
    <i class="fa fa-arrow-left"></i>
    <span>Return to App</span>
  </div>
  <div *ngIf="isAdminRoute && !appNavigation" class="top-header-icon user-dd-menu" (click)="userDropDown()">
    <i style="font-size: 24px" class="user-icon"></i>
  </div>
</div>
<app-global-search #globalSearch></app-global-search>
<app-notification
  *ngIf="isNotificationListVisible"
  [headlessService]="headlessService"
  (removeNotificationEvent)="handleRemoveNotification($event)"
  (markAsReadEvent)="handleMarkAsRead($event)"
  (markAllLoadUnreadCount)="loadUnreadCount()"
>
</app-notification>
<app-user-drop-down [isAdminRoute]="isAdminRoute" *ngIf="isUserDropDownVisible"></app-user-drop-down>

@if (environmentName === 'Development') {
  <app-draggable-dev-tools/>
}
